import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Font } from '../../fonts';

export interface MetaItemWidgetProps {
  icon: IconProp;
  value: string;
  primary?: boolean;
}

export const MetaItemWidget: React.FC<MetaItemWidgetProps> = observer((props) => {
  return (
    <S.Meta primary={!!props.primary}>
      <S.Icon icon={props.icon} />
      <S.Value>{props.value}</S.Value>
    </S.Meta>
  );
});
namespace S {
  export const Meta = styled.div<{ primary: boolean }>`
    font-size: 16px;
    font-family: ${Font.Special};
    color: ${(p) => (p.primary ? p.theme.text.special : p.theme.text.primary)};
    display: flex;
    flex-direction: row;
    column-gap: 5px;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    opacity: 0.5;
  `;

  export const Value = styled.div``;
}
